<template>
  <a
    class="frisbuy-good-item frisbuy-goods-popup-good"
    target="_blank"
    :href="good.link"
    @click="$emit('clickLink', good)"
  >
    <img
      v-if="good.sku.thumbUrl"
      class="frisbuy-goods-popup-good__img"
      :src="getDomainSubstitute(good.sku.thumbUrl)"
      @error="errorImageHandler"
    />
    <div
      v-else
      class="frisbuy-goods-popup-good__img frisbuy-goods-popup-good__img--empty"
    >
      <svg
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.0989 0.000416369C25.2137 -0.0246793 22.4345 1.08555 20.3597 3.09128L20.3349 3.1156L17.3765 6.05966C16.4365 6.99507 16.4327 8.5154 17.3682 9.4554C18.3036 10.3954 19.8239 10.3991 20.7639 9.4637L23.7091 6.5329C24.8771 5.40947 26.4378 4.78847 28.0572 4.80256C29.6818 4.81669 31.2364 5.46895 32.3859 6.61956C33.5355 7.77025 34.188 9.32732 34.2022 10.9555C34.2162 12.5774 33.5958 14.1397 32.4747 15.3087L27.3306 20.4577L27.3303 20.4581C26.7017 21.0874 25.9454 21.574 25.1128 21.8849C24.2801 22.1958 23.3905 22.3238 22.5042 22.2602C21.6179 22.1967 20.7555 21.9431 19.9755 21.5166C19.1955 21.09 18.5161 20.5005 17.9835 19.7877C17.1897 18.7255 15.685 18.5079 14.6227 19.3017C13.5605 20.0955 13.3429 21.6002 14.1367 22.6625C15.0814 23.9267 16.2869 24.9729 17.6714 25.73C19.0559 26.4872 20.587 26.9375 22.1608 27.0503C23.7347 27.1631 25.3143 26.9358 26.7926 26.3838C28.2708 25.8319 29.6131 24.9682 30.7282 23.8516L35.8881 18.6869C35.8979 18.6771 35.9076 18.6671 35.9173 18.6571C37.921 16.5806 39.0294 13.7998 39.0043 10.9139C38.9792 8.02792 37.8228 5.26684 35.7833 3.22541C33.7437 1.18391 30.9842 0.0255121 28.0989 0.000416369ZM16.8439 11.9594C15.27 11.8466 13.6904 12.0739 12.2121 12.6258C10.734 13.1777 9.39191 14.0413 8.2768 15.1578L8.27669 15.1579L8.27649 15.1581L3.11667 20.3228C3.10684 20.3326 3.09709 20.3425 3.08743 20.3525C1.08371 22.4291 -0.0246385 25.2099 0.000415696 28.0958C0.0254702 30.9817 1.18193 33.7428 3.22143 35.7842C5.261 37.8257 8.02052 38.9841 10.9058 39.0092C13.791 39.0343 16.5702 37.9241 18.645 35.9184C18.655 35.9087 18.6649 35.899 18.6747 35.8891L21.616 32.9451C22.5533 32.0069 22.5526 30.4866 21.6144 29.5493C20.6762 28.612 19.1559 28.6127 18.2186 29.5509L15.2933 32.479C14.1255 33.601 12.5658 34.2212 10.9475 34.2071C9.32288 34.193 7.76832 33.5407 6.61879 32.3901C5.46918 31.2394 4.81669 29.6823 4.80256 28.0541C4.78848 26.4323 5.40888 24.87 6.52997 23.701L11.6742 18.5519L11.6745 18.5516C12.303 17.9222 13.0593 17.4357 13.892 17.1248C14.7246 16.8139 15.6142 16.6859 16.5005 16.7494C17.3868 16.813 18.2492 17.0665 19.0292 17.4931C19.8092 17.9196 20.4886 18.5092 21.0212 19.2219C21.815 20.2842 23.3197 20.5018 24.382 19.708C25.4443 18.9141 25.6619 17.4094 24.868 16.3472C23.9233 15.083 22.7178 14.0368 21.3334 13.2796C19.9489 12.5225 18.4177 12.0722 16.8439 11.9594Z"
          fill="#898989"
        />
      </svg>
    </div>

    <div class="frisbuy-goods-popup-good__description">
      {{ good.title === "" ? getInstagramLinkData(good.link) : good.title }}
    </div>
    <div
      v-if="good.sku && good.sku.price"
      class="frisbuy-goods-popup-good__price"
    >
      <span
        v-if="good.sku.priceDiscount"
        class="frisbuy-goods-popup-good__price-discount"
      >
        {{ `-${good.sku.priceDiscount}%` }}
      </span>
      <span class="frisbuy-goods-popup-good__price-now">
        {{ good.sku.price }}
        {{ currencySymbol }}
      </span>
      <span
        v-if="good.sku.priceOld"
        class="frisbuy-goods-popup-good__price-old"
      >
        {{ good.sku.priceOld }}{{ currencySymbol }}
      </span>
    </div>
    <div v-else class="frisbuy-goods-popup-good__price">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.86918 0.07573C8.65763 0.161024 8.52691 0.389931 8.52691 0.675251C8.52691 0.836557 8.69198 1.05777 9.19899 1.57604L9.87099 2.263L8.32139 3.80727C7.4691 4.65664 6.73277 5.42207 6.6851 5.50832C6.5282 5.79229 6.48014 6.17933 6.56176 6.50114C6.66194 6.8958 7.12469 7.33219 7.52216 7.40677C8.13547 7.52182 8.29649 7.41058 10.0312 5.67272L11.6544 4.04657L12.3803 4.75852C13.105 5.46944 13.2775 5.56021 13.6395 5.42128C13.963 5.2971 14 5.0217 14 2.74089C14 0.429127 13.9737 0.240368 13.6306 0.0839024C13.3965 -0.0228149 9.13189 -0.0301146 8.86918 0.07573ZM1.86014 1.3734C1.15157 1.56454 0.497575 2.13287 0.169507 2.84253C0.00277629 3.2033 0 3.28138 0 7.6525C0 12.0387 0.00222092 12.1005 0.171411 12.4668C0.41413 12.9922 0.934074 13.5237 1.45616 13.7802L1.90368 14H6.34561H10.7875L11.2351 13.7802C11.7579 13.5233 12.278 12.9911 12.5186 12.4668C12.6705 12.1357 12.6919 11.9272 12.717 10.5287L12.7452 8.96167H11.4689H10.1926V10.2312V11.5007H6.34561H2.49858V7.6525V3.80433H3.76771H5.03683V2.53483V1.26533L3.6289 1.27065C2.78303 1.2739 2.07692 1.31492 1.86014 1.3734Z"
          fill="white"
        />
      </svg>
    </div>

    <button class="frisbuy-goods-popup-good__buy-button">
      <span class="frisbuy-good-buy-button__text">Купить</span>
    </button>
  </a>
</template>

<style scoped lang="scss">
*,
*::before,
*::after {
  font-family: Helvetica;
}

.frisbuy-goods-popup-good {
  display: block;
  // grid-column: 150px 53px 52px 34px;

  // width: 150px;
  // height: 270px;
  height: 100%;
  aspect-ratio: 150 / 270;

  text-decoration: none;
  color: #000000;

  // margin-left: 20px;
  // margin-right: 20px;

  &__img {
    display: block;
    position: relative;

    // width: 150px;
    width: 100%;
    height: unset;
    aspect-ratio: 1 / 1;

    object-fit: cover;
    object-position: center;

    &--empty {
      background-color: #e7e7e7;

      & > svg {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  &__description {
    width: 100%;
    height: 11.851852%;

    font-size: 14px;
    // font-size: calc(14px * (0.09333333 * 100));
    // font-size: calc((100vw - 42rem) / 25 + 1rem);
    // font-size: calc((100vw - 38.8rem) / 25 + 1rem);
    line-height: calc(16px / 14px);
    text-align: left;
    text-overflow: ellipsis;
    // white-space: nowrap;

    overflow: hidden;

    margin-top: 3.703704%;
  }

  &__price {
    display: block;
    position: relative;

    width: 100%;
    height: 20px;

    color: #ffffff;
    white-space: nowrap;

    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;

    border-radius: 30px;

    // margin-top: 28px;
    margin-top: 12px;

    & > * {
      vertical-align: baseline;
    }

    &-discount {
      // NOTE: display on via sonata
      display: none;
      color: #d63868;

      margin-right: 8px;
    }

    &-now {
      color: #222222;
    }

    &-old {
      color: #8a8a8a;
      text-decoration-line: line-through;

      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0em;
      text-align: left;
      color: #7e7e7e;

      margin-left: 8px;
    }
  }

  &__buy-button {
    width: 100%;
    height: 34px;

    border-radius: 2px;
    border: 1px solid black;

    color: #000;
    background-color: #fff;

    cursor: pointer;

    margin-top: 12px;
    padding: 0;
  }
}
</style>

<script>
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  emits: ["clickLink"],

  props: {
    good: {
      type: Object,
      require: true,
    },

    currencySymbol: {
      type: String,
      require: false,
      default: "₽",
    },
  },

  data() {
    return {};
  },

  methods: {
    getInstagramLinkData(link) {
      const splittedLink = link.split("/");

      const isInstagramPost = link.includes("instagram");
      if (!isInstagramPost) return "";

      const isTag = splittedLink.includes("tags");
      if (isTag) return `#${splittedLink[splittedLink.indexOf("tags") + 1]}`;

      const isLocation = splittedLink.includes("locations");
      if (isLocation) return "📌 Локация";

      if (splittedLink.length === 5) return `@${splittedLink[3]}`;

      return "Пост";
    },

    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e) {
      MediaCatcher(e, 2, widgetTypes.STORY);
    },
  },
};
</script>
